/**
 * システムで利用する重要なグローバル定数群
 */

// コントローラー一覧 cm73_permissionsのjson_dataの順と合わせる必要がある
export const CONTROLLER_LIST = [
    "Record","User","Device","Permission",
    "Category","ProperNoun","PhoneBook","AlarmSetting","NotificationSetting",
    "VocHistory","VocCategory","Partner"
];

// scope_code一覧
export const LEVEL_OBJECT = {
    system: {name: "system", value: 100},
    company: {name: "company", value: 200},
    user: {name: "user", value: 300},
};

// 【#475】権限プロファイルに機能キーが無いときの既定値。
// App.js のフォールバックと権限管理画面の初期化（Permission.js の getPermissionReset）が
// 同じ値を別々に持っていたため、ここへ寄せて食い違いを構造的に防ぐ。
// 申請 SQL（docs/data-request-hm73-permissions-controller-keys.md）の既定値もこれに合わせる。
export const DEFAULT_PERMISSION = {
    level: LEVEL_OBJECT.user.name,
    create: false,
    read: false,
    update: false,
    delete: false,
    download: false,
    playback: false,
};

// オプション機能一覧
export const OPTIONS = {
    customer_infos: "電話帳機能",
    RecAceApp: "RecACEアプリ",
    aspire: "Aspire内線番号"
};

// 会社オプションでゲートするユーザーオプションのマッピング
// キー: ユーザーオプション名 (OPTIONS のキー), 値: 必要な company_options フラグ名
// ここに載っているオプションは、company_options[値] が真の会社のユーザー編集モーダルでのみ表示される。
// 載っていないオプションは従来通り全会社で表示。
// 現状は aspire のみキーと値が同一だが、将来 OPTIONS のキーと company_options のフラグ名が
// 異なる場合 (例: 'recAce' → 'rec_ace_enabled') にもキー/値を別々に指定して対応可能。
export const COMPANY_GATED_OPTIONS = {
    aspire: "aspire"
};

// 設定値
export const VALUES = {
    audio2text_free_hour: 0.5,
    audio2text_inv_yen: 600,
    audio2text_inv_hour: 3,
    header_height: 71,
    table_size_tune: 150,
    // 【#541】サブID（サブユーザー）作成上限。hm15_users.options.sub_user_limit に保存し、
    // 未設定のユーザーは従来どおり 5 件として扱う。上限は誤入力（0 を余分に付けるなど）で
    // 大量の Cognito ユーザーが作られるのを防ぐための hard cap で、サーバー側
    // （server/app/controllers/components/SubUserLimit.js）と同じ値を持つ。
    sub_user_limit_default: 5,
    sub_user_limit_min: 1,
    sub_user_limit_max: 100
};
